export const storage = {
  local: "Local",
  ftp: "FTP",
  sftp: "S-FTP",
  host: "Host",
  port: "Port",
  username: "Username",
  password: "Password",
  ssl: "SSL",
  passive: "Passive",
  timeout: "Timeout",
  root: "Root",
  typeSelect: "Select type"
};
